import { ReactNode } from 'react';
import { ScholarshipStatus } from '@common-types';

import ScholarshipIcon from '@images/ScholarshipsIcons/scholarship.svg?react';
import FellowshipIcon from '@images/ScholarshipsIcons/fellowship.svg?react';
import GrantIcon from '@images/ScholarshipsIcons/grant.svg?react';
import ForgivableLoanIcon from '@images/ScholarshipsIcons/forgivable-loan.svg?react';
import PrizeIcon from '@images/ScholarshipsIcons/prize.svg?react';

export const SMALL_DESC_LENGTH = 136;
export const WIDE_DESC_LENGTH = 200;

export const AWARD_TYPE_ICONS: { [key: string]: ReactNode } = {
  SCHOLARSHIP: <ScholarshipIcon data-testid="scholarshipIcon" />,
  FELLOWSHIP: <FellowshipIcon data-testid="fellowshipIcon" />,
  GRANT: <GrantIcon data-testid="grantIcon" />,
  'FORGIVABLE LOAN': <ForgivableLoanIcon data-testid="forgivableLoanIcon" />,
  PRIZE: <PrizeIcon data-testid="prizeIcon" />,
};

export const getMonthName = (monthNumber: number) => {
  const date = new Date(2000, monthNumber - 1, 1);

  return date.toLocaleString('en-US', {
    month: 'short',
  });
};

export const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export const TAGS_COLORS: { [key: string]: string } = {
  [ScholarshipStatus.IN_PROGRESS]: '#ED6C02',
  [ScholarshipStatus.APPLIED]: '#0C938F',
  [ScholarshipStatus.WINNER]: '#8E2880',
  [ScholarshipStatus.CHANGED]: '#464a4f',
} as const;
